import { observer } from 'mobx-react';
import { FC, useCallback, useMemo } from 'react';
import { customerProfileEditStore } from '../../store';
import { GENDER, ICustomerProfile } from '../../types';
import { countriesStore } from 'src/mobx/countriesStore';
import { localeStore } from 'src/mobx/localesStore';
import Calendar from 'src/view/components/Calendar/Calendar';
import Input from 'src/view/components/Controls/InputComponent/Input';
import PhoneInput from 'src/view/components/Controls/PhoneInput/PhoneInput';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

const CustomerProfileEditMain: FC = observer((): JSX.Element => {
  const { customer, validation, editCustomerHandler, editCustomerBirthday, editCustomerGender } = customerProfileEditStore;

  const onEdit = useCallback(
    (field: keyof ICustomerProfile) => (value: string | undefined) => {
      editCustomerHandler({ [field]: value });
    },
    []
  );

  const onMobileEdit = useCallback((mobile: string) => {
    editCustomerHandler({ mobile });
  }, []);

  const genders = useMemo((): IPickerOption[] => {
    return [
      { value: GENDER.MALE, label: 'txt_male' },
      { value: GENDER.FEMALE, label: 'txt_female' },
    ];
  }, []);

  return (
    <div className="d-flex flex-column gap-15">
      <div className="d-flex flex-row align-items-center">
        <Text type={TEXT.ORDER_FIELD} text="name" className="customer-profile-edit__input-title" />
        <Input type="text" value={customer.name} onChangeValue={onEdit('name')} placeholder={localeStore.t('Value')} />
      </div>

      <div className="d-flex flex-row align-items-center">
        <Text type={TEXT.BLOCK_HEADER} text="mobile" required className="customer-profile-edit__input-title" />
        <PhoneInput
          value={customer.mobile}
          onChange={onMobileEdit}
          disabled
          onlyCountries={countriesStore.countriesForPhoneInput}
          className={`customer-profile-edit__mobile ${customer.is_draft ? '' : 'customer-profile-edit__mobile_disable'}`}
        />
      </div>

      <div className="d-flex flex-row align-items-center">
        <Text type={TEXT.ORDER_FIELD} text="Birthday" className="customer-profile-edit__input-title" />
        <Calendar
          start_date={customer.birth_day || undefined}
          end_date={undefined}
          changeDate={editCustomerBirthday}
          horizontal="end"
          vertical="bottom"
          fieldClassName="customer-profile-edit__calendar"
          //
          minDate={new Date(1900, 0, 1)}
          defaultView="decade"
          selectRange={false}
        />
      </div>

      <div className="d-flex flex-row">
        <Text
          type={TEXT.ORDER_FIELD}
          text="email_placeholder"
          className="customer-profile-edit__input-title-with-error customer-profile-edit__input-title"
        />
        <Input type="text" value={customer.email || ''} onChangeValue={onEdit('email')} placeholder="email@mail.com" validation={validation.email} />
      </div>

      <div className="d-flex flex-row align-items-center">
        <Text type={TEXT.ORDER_FIELD} text="Gender" className="customer-profile-edit__input-title" />
        <TabPicker value={customer.gender} options={genders} onChange={editCustomerGender} />
      </div>
    </div>
  );
});

export default CustomerProfileEditMain;
